import React from 'react';

import { CmTable, CmTableHeader, CmTbody, CmTh } from '@/components/uiParts';
import { PosDataLevel, PosOption } from '@/domain/models/Pos';
import {
  mappingPosDataLevel,
  MappingPosDataLevelThs,
  PosItemAndHandlePos,
  posItemColumn,
} from '@/services/Pos';

import { PosTableAccordionItem } from './PosTableAccordionItem';

interface Props {
  posItems?: PosItemAndHandlePos[];
  posOption?: PosOption;
  posDataLevel: PosDataLevel;
  handleInputPosCode: (index: number, newPosCode: string) => void;
  handleInputPromotionOneFreePosCode: (
    index: number,
    newPromotionOneFreePosCode: string
  ) => void;
  handleResetPosCode: (index: number) => void;
  handleResetPromotionOneFreePosCode: (index: number) => void;
}

export const PosItemTable: React.VFC<Props> = ({
  posItems,
  posOption,
  posDataLevel,
  handleInputPosCode,
  handleInputPromotionOneFreePosCode,
  handleResetPromotionOneFreePosCode,
  handleResetPosCode,
}) => {
  return (
    <CmTable>
      <CmTableHeader>
        <CmTh padding="10px">{posItemColumn.itemName.label}</CmTh>
        {/* TODO 互換性がないというエラーが出るため、下記`as`のHACK的なやり方で対応をする。typescriptのverv4.3.5であれば解消できる様子なのでその際にasを削除対応をとる */}
        {(
          mappingPosDataLevel[posDataLevel].ths as MappingPosDataLevelThs[]
        ).map((th) => (
          <CmTh padding="10px" key={th}>
            {th}
          </CmTh>
        ))}
        <CmTh padding="10px" width="120px">
          {posItemColumn.posItemCode.label}
        </CmTh>
        {posOption?.type === 'promotion' &&
          posOption.value === 'buy_one_get_one_free' && (
            <CmTh padding="10px" width="120px">
              {posItemColumn.promotionOneFreePosCode.label}
            </CmTh>
          )}
        <CmTh padding="10px" width="30px" />
      </CmTableHeader>
      <CmTbody>
        {posItems?.map((posItem, index) => (
          <PosTableAccordionItem
            key={index}
            {...{
              index,
              posItem,
              posOption,
              posDataLevel,
              handleInputPosCode,
              handleInputPromotionOneFreePosCode,
              handleResetPromotionOneFreePosCode,
              handleResetPosCode,
            }}
          />
        ))}
      </CmTbody>
    </CmTable>
  );
};
